export var ErrorCodeCategory;
(function (ErrorCodeCategory) {
    ErrorCodeCategory["accessDenied"] = "kAccessDenied";
    ErrorCodeCategory["notLoggedIn"] = "kNotLoggedIn";
    ErrorCodeCategory["validationError"] = "kValidationError";
})(ErrorCodeCategory || (ErrorCodeCategory = {}));
export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["ACCESS_DENIED_ACCOUNT_LOCKED"] = "iam.accessDenied.accountLocked";
    ErrorCode["ACCESS_DENIED_INVALID_CREDENTIALS"] = "iam.accessDenied.invalidCredentials";
    ErrorCode["ACCESS_DENIED_PASSWORD_EXPIRED"] = "iam.accessDenied.passwordExpired";
    ErrorCode["ACCESS_DENIED_INVALID_TOKEN"] = "mom.accessDenied.invalidToken";
    ErrorCode["ACCESS_DENIED_REDEPLOYMENT"] = "mom.accessDenied.redployment";
    ErrorCode["ACCESS_DENIED_TARGET_ORG"] = "mom.accessDenied.targetOrg";
    ErrorCode["ACCESS_DENIED_UPDATE_ENVIRONMENT_ACCESS"] = "mom.accessDenied.updateEnvironmentAccess";
    ErrorCode["ACCESS_DENIED_STUDY_DEPLOYMENT_ACCESS"] = "mom.accessDenied.studyDeploymentAccess";
    ErrorCode["CONFLICT_INSTANCE_DELETE"] = "mom.conflict.instanceDelete";
    ErrorCode["ENTITY_ACCESS_EXISTS"] = "mom.conflict.entityAccessExists";
    ErrorCode["SITE_NUMBER_EXISTS"] = "mom.conflict.siteNumberExists";
    ErrorCode["EXISTING_SITE_IN_ENVIRONMENT"] = "mom.conflict.workspaceSiteExistsInEnvironment";
    ErrorCode["IDENTITY_NOT_VERIFIED"] = "iam.accessDenied.unverified";
    ErrorCode["PASSWORD_STRENGTH"] = "iam.invalidArgument.passwordStrength";
    ErrorCode["PROD_ENVIRONMENT_LIMIT_REACHED"] = "mom.accessDenied.maxEnvironments";
    ErrorCode["USED_PASSWORD"] = "iam.invalidArgument.usedPassword";
    ErrorCode["ACCESS_DENIED_SSO_REQUIRED"] = "iam.accessDenied.ssoRequired";
    ErrorCode["INVALID_ARGUMENT_INVALID_TOKEN"] = "iam.invalidArgument.invalidToken";
})(ErrorCode || (ErrorCode = {}));
